import { Component, Input, OnDestroy, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { PublicationService } from '../../../services/publication.service';
import { AuthenticationService } from '../../../services/authentication.service';
import { Subscription } from 'rxjs';
import { Embargo } from '../../../components/shared/bb-embargo/bb-embargo.component';
import { Publication } from '../../../interfaces/publication';
import { TranslateService } from '@ngx-translate/core';
import { DialogDefinition, ModalDefinition, NoticeDefinition, OverlayService } from 'app/services/overlay.service';
import { SapiService } from 'app/services/sapi.service';
import { MediaProfile } from 'app/interfaces/mediaProfile';
import { LocalStorageService } from 'angular-2-local-storage';

@Component({
	selector: 'upload-transcode-upload',
	templateUrl: './upload-transcode-upload.component.html',
	styleUrls: ['./upload-transcode-upload.component.scss']
})

export class UploadTranscodeUploadComponent implements OnInit, OnDestroy {
	@ViewChild('createPresetTemplate') createPresetTemplate: TemplateRef<any>;
	@ViewChild('matSelect') matSelect = null;
	@Input() autoName: boolean;
	@Input() autoPublish: boolean;
	@Input() embargo: Embargo;

	activeTab: string;
	subscriptions: Subscription;
	putRight: boolean;
	waitForImport: boolean;
	disableImport = false;
	presetModal: ModalDefinition;

	selectedProfile: string;
	mediaProfiles: any[] = [];

	constructor(
		private publicationService: PublicationService,
		private authenticationService: AuthenticationService,
		private overlayService: OverlayService,
		private sapiService: SapiService,
		private translate: TranslateService,
		private localStorageService: LocalStorageService) {

		this.authenticationService.hasPermission('put').subscribe(hasRight => this.putRight = hasRight);
		this.subscriptions = new Subscription();
	}

	ngOnInit() {
		this.subscriptions.add(
			this.publicationService.getData(true).subscribe((publicationData: Publication) => {
				if (publicationData) {
					this.disableImport = publicationData.disableImport;
				}
			})
		);

		this.getProfiles();
	}

	ngOnDestroy() {
		if (this.subscriptions) {
			this.subscriptions.unsubscribe();
		}
	}

	settingsChanged() {
		if (this.localStorageService.get('ovp-autoName') === null && this.localStorageService.get('ovp-autoPublish') === null) {
			const notice: NoticeDefinition = {
				icon: 'warning',
				title: this.translate.instant('CHANGE_UPLOAD_SETTINGS'),
				type: 'warning',
				contents: this.translate.instant('CHANGE_UPLOAD_SETTINGS_REMEMBER')
			};
			this.overlayService.createNotice(notice);
		}
		this.localStorageService.set('ovp-autoName', this.autoName);
		this.localStorageService.set('ovp-autoPublish', this.autoPublish);
		this.localStorageService.set('ovp-uploadPreset', this.selectedProfile);
	}

	getProfiles(newProfile?) {
		this.mediaProfiles = [];
		this.sapiService.getUrl('/mediaprofile').subscribe((mediaProfile: MediaProfile) => {
			if (mediaProfile && mediaProfile.items) {
				mediaProfile.items.forEach((item) => {
					this.mediaProfiles.push(item);
					if (newProfile) {
						this.selectedProfile = newProfile;
					} else if (item.name === 'default') {
						this.selectedProfile = item.name;
					}
				});
			}
			if (this.localStorageService.get('ovp-uploadPreset') !== null && !newProfile) {
				this.selectedProfile = this.localStorageService.get('ovp-uploadPreset');
				const profileSet = this.mediaProfiles.find(setProfile => setProfile.name === this.selectedProfile);
				if (!profileSet) {
					this.selectedProfile = 'default';
				};
			}
		});
	}

	deleteProfile(profile) {
		const config = { entity: this.translate.instant('PRESET').toLowerCase(), id: profile.name };;
		const dialog: DialogDefinition = {
			icon: 'trash',
			title: this.translate.instant('DELETE_ENTITY', config),
			contents: this.translate.instant('DELETE_ENTITY_CONFIRM', config),
			onConfirm: () => {
				this.overlayService.setLoading(true);
				this.sapiService.delete('mediaprofile', profile.id).subscribe(
					(data) => {
						const msg = this.translate.instant('ENTITY_DELETED', config);
						this.overlayService.createToast(msg, 'info-circle');
						this.getProfiles();
						this.overlayService.setLoading(false);
					},
					(err) => {
						this.overlayService.createToast(this.translate.instant('ERROR'), 'warning');
						this.overlayService.setLoading(false);
					}
				);
				this.overlayService.setLoading(false);
			}
		};
		this.overlayService.createDialog(dialog);
	}

	createPreset() {
		this.matSelect.close();
		this.presetModal = {
			icon: '',
			title: 'Create new preset',
			component: {
				name: 'custom-content',
				templateRef: this.createPresetTemplate
			}
		};
		this.overlayService.createModal(this.presetModal);
	}

	closeModal(newProfile) {
		this.overlayService.removeModal(this.presetModal);
		this.getProfiles(newProfile);
	}
}
